<template>
    <div class="Header">
        <span class="Label">Selected filters</span>
        <button
            type="button"
            class="Clear"
            aria-label="Clear All"
            @click="cleanFilters"
        >
            Clear all
        </button>
    </div>
</template>

<script setup lang="ts">
import { useSearchStore } from '@app/stores/useSearchStore';

const searchStore = useSearchStore();

const cleanFilters = (): void => {
    searchStore.cleanFilters();
};
</script>

<style scoped lang="scss">
.Header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include MarginAreas(0, 0, 1, 0);

    .Label {
        display: block;
        color: $Grey-900;
        user-select: none;

        @include TextStyle(HeadingExtraSmall);
    }

    .Clear {
        background: none;
        border: none;
        color: $Blue-700;
        cursor: pointer;

        @include TextStyle(BodySmallRegular);
        @include PaddingAreas(0);
    }

}
</style>